
import feathersClient from '../../feathers-client';

export default {
	state: {
		trustJobTitleType: [],

	},
	getters: {


	},
	mutations: {
		SET_TRUST_JOB_TITLES: (state, jobTitles) => {
			state.trustJobTitleType = jobTitles;
		},
	},
	actions: {
		trustRoleType: async({ rootGetters, commit, rootState }, filter) => {
			const results = await feathersClient.service('/api/v3/trust-role-types').find({
				query: {
					$role: rootGetters.currentUserRole,
					trustId: rootState?.organizationStore?.currentTrustId,
					fields: ['jobTitleType', 'optimaMappings'],
					...filter,
				},
			});
			commit('SET_TRUST_JOB_TITLES', results?.data);
			return results.data;
		},
		// eslint-disable-next-line no-unused-vars
		// getOptimaRoleTypeMapping: async({ rootGetters }, filter) => {
		// 	const results = await feathersClient.service('/api/v3/optima-mappings').find({
		// 		query: {
		// 			// $role:rootGetters.currentUserRole,
		// 			$getJobTitles: true,
		// 			...filter,
		// 		},
		// 	});
		// 	return results;
		// },
		// eslint-disable-next-line no-unused-vars
		getRoleTypeMappingByID: async function({ rootGetters }, id) {
			const results = await feathersClient.service('/api/v3/optima-mappings').find({
				query: {
					$role:rootGetters.currentUserRole,
					// trustId:rootState?.organizationStore?.currentTrustId
					jobTitleTypeId: id,
					$getjobTitleType: true,
				},
			});
			return results;
		},
		createOptimaTrustRoleTypeMapping: async function ({ rootGetters }, data) {
			const results = await feathersClient.service('/api/v3/optima-mappings').create(data, {
				query: {
					$createjobTitleTypeMapping: true,
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		deleteOptimaTrustRoleTypeMapping: async function ({ rootGetters }, data) {
			const results = await feathersClient.service('/api/v3/optima-mappings').remove(null, {
				query: {
					$deleteJobTitleTypeMapping: true,
					$role: rootGetters.currentUserRole,
					...data,
				},
			});
			return results;
		},

	},
};
